import PropTypes from 'prop-types'
import React from 'react'

const PencilIcon = ({
   color,
   width,
   height
}) => (
   <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      xmlSpace="preserve"
      width={width}
      height={height}>
      <g
         fill={color}>
         <path
            d="M22.707,5.293l-4-4a1,1,0,0,0-1.414,0L14.5,4.086,19.914,9.5l2.793-2.793A1,1,0,0,0,22.707,5.293Z"
         />
         <path
            d="M13.086,5.5,3.293,15.293a1,1,0,0,0-.241.391l-2,6A1,1,0,0,0,2,23a.987.987,0,0,0,.316-.052l6-2a1,1,0,0,0,.391-.241L18.5,10.914Z"
            fill={color}
         />
      </g>
   </svg>
)

PencilIcon.propTypes = {
   color: PropTypes.string,
   height: PropTypes.string,
   width: PropTypes.string
}

PencilIcon.defaultProps = {
   color: '#444',
   height: '60px',
   width: '60px'
}

export default React.memo(PencilIcon)
